import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var TextIcon32Regular = forwardRefAndName('TextIcon32Regular', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref,
      viewBoxSize: 32
    }, props), /*#__PURE__*/
    React.createElement("path", {
      d: "M10 12C10 11.4477 10.4477 11 11 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H17V22C17 22.5523 16.5523 23 16 23C15.4477 23 15 22.5523 15 22V13H11C10.4477 13 10 12.5523 10 12Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 7.5C4 4.46243 6.46243 2 9.5 2H18.2261C19.287 2 20.3044 2.42143 21.0546 3.17157L26.8284 8.94543C27.5786 9.69558 28 10.713 28 11.7739V24.5C28 27.5376 25.5376 30 22.5 30H9.5C6.46243 30 4 27.5376 4 24.5V7.5ZM9.5 4C7.567 4 6 5.567 6 7.5V24.5C6 26.433 7.567 28 9.5 28H22.5C24.433 28 26 26.433 26 24.5V11.7739C26 11.2434 25.7893 10.7347 25.4142 10.3596L19.6404 4.58579C19.2653 4.21071 18.7566 4 18.2261 4H9.5Z"
    }))
  );
});